import { memo, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import { Outlet, useNavigate } from "react-router-dom";

import { Logo } from "@zenith/shared";
import { getCopyright } from "@zenith/utils";
import {
  usePaymentLinkContext,
  usePaymentsContext,
} from "@zenith/context/global-context/hooks";
import {
  PAYMENT_LINK,
  PAYMENT_LINK_METHOD_PAGE,
  PAYMENT_LINK_SUCCESS,
} from "@zenith/routes/paths";

/* eslint-disable-next-line */
export interface PaymentLinkLayoutProps {}

const PaymentLinkLayout = memo(function PaymentLinkLayout(
  props: PaymentLinkLayoutProps
) {
  const { operationId } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { paymentLinkContext } = usePaymentLinkContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (operationId && operationId !== "cfe5f4e9-3a7d-41c1-85dc-1235464ee073") {
      localStorage.setItem("paymentLinkOperationId", operationId);
    }
  }, [operationId]);

  const location = useLocation();
  const [pollingActive, setPollingActive] = useState(false);

  const { paymentsContext, setPaymentsContext } = usePaymentsContext();

  function isLocationValid() {
    return (
      location.pathname.includes(PAYMENT_LINK_METHOD_PAGE) ||
      location.pathname.includes("/bank-transfer-details") ||
      location.pathname.includes("/bank-transfer-pending") ||
      location.pathname.includes("/ussd-details") ||
      location.pathname.includes("/ussd-pending") ||
      location.pathname.includes("/qr-code-details") ||
      location.pathname.includes("/qr-code-pending") ||
      location.pathname.includes("/card-details")
    );
  }

  useEffect(() => {
    const shouldPoll = isLocationValid() && !isLoading;

    if (shouldPoll && !pollingActive) {
      setPollingActive(true);
    } else if (!shouldPoll && pollingActive) {
      setPollingActive(false);
    }
  }, [location.pathname, isLoading]);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-white">
      <>
        {!location.pathname.includes(PAYMENT_LINK_SUCCESS) && (
          <div className="logo mt-12 mb-auto flex h-7">
            <Logo className="flex" />
          </div>
        )}

        <div className="form mt-10 flex h-full w-full justify-center md:w-3/5">
          <Outlet />
        </div>

        <div className="mt-20 mb-8 flex h-10">
          <div className="text-sm font-normal text-neutral-300">
            {getCopyright()}
          </div>
        </div>
      </>
    </div>
  );
});

export default PaymentLinkLayout;
